/**
 * Sticky-header state toggle. Adds .rsv-header--scrolled once the page
 * has scrolled past the hero threshold. Uses a passive scroll listener
 * with rAF throttling to stay off the main-thread critical path (INP).
 */

const SCROLL_THRESHOLD = 24;

export function initStickyHeader() {
  const header = document.querySelector('[data-site-header]');

  if (!header) {
    return;
  }

  let ticking = false;

  function update() {
    header.classList.toggle('rsv-header--scrolled', window.scrollY > SCROLL_THRESHOLD);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
}
